/**
 * Skio plan picker: default / restore one-time after re-inits (flavor swap), and
 * keep the user's Subscribe vs one-time choice when Skio re-hydrates late.
 */
(function () {
  const STORAGE_KEY = "lasso-skio-plan-pref";

  function getPreference() {
    try {
      return sessionStorage.getItem(STORAGE_KEY);
    } catch {
      return null;
    }
  }

  function setPreference(mode) {
    try {
      if (mode == null) sessionStorage.removeItem(STORAGE_KEY);
      else sessionStorage.setItem(STORAGE_KEY, mode);
    } catch {
      /* noop */
    }
  }

  function applyPlanPreference(fieldset) {
    if (!fieldset || !fieldset.matches?.("fieldset.skio-plan-picker")) return;
    const onetime = fieldset.querySelector('input.skio-group-input[type="radio"][skio-one-time]');
    const subscribe = fieldset.querySelector(
      'input.skio-group-input[type="radio"][skio-selling-plan-group]'
    );
    if (!onetime || !subscribe) return;

    const pref = getPreference();
    if (pref === "subscribe") {
      if (!subscribe.checked) subscribe.click();
      return;
    }
    if (!onetime.checked) onetime.click();
  }

  function scanAll() {
    document.querySelectorAll("fieldset.skio-plan-picker").forEach(applyPlanPreference);
  }

  function scheduleRetries() {
    requestAnimationFrame(scanAll);
    setTimeout(scanAll, 0);
    setTimeout(scanAll, 50);
    setTimeout(scanAll, 100);
    setTimeout(scanAll, 200);
    setTimeout(scanAll, 350);
    setTimeout(scanAll, 600);
    setTimeout(scanAll, 1000);
    setTimeout(scanAll, 2000);
    setTimeout(scanAll, 3500);
    setTimeout(scanAll, 5000);
    setTimeout(scanAll, 7500);
    setTimeout(scanAll, 10000);
  }

  let reassertDebounce;
  let reassertBudget = new WeakMap();

  document.addEventListener("change", (e) => {
    const input = e.target;
    if (!input.matches?.("input.skio-group-input[type='radio']")) return;
    const fs = input.closest("fieldset.skio-plan-picker");
    if (!fs || !input.checked) return;

    if (e.isTrusted) {
      if (input.hasAttribute("skio-one-time")) setPreference("onetime");
      else if (input.hasAttribute("skio-selling-plan-group")) setPreference("subscribe");
      return;
    }

    if (!input.hasAttribute("skio-selling-plan-group")) return;
    if (getPreference() !== "onetime") return;

    clearTimeout(reassertDebounce);
    reassertDebounce = setTimeout(() => {
      const onetime = fs.querySelector('input.skio-group-input[type="radio"][skio-one-time]');
      const sub = fs.querySelector('input.skio-group-input[type="radio"][skio-selling-plan-group]');
      if (!onetime || !sub || !sub.checked || getPreference() !== "onetime") return;

      const now = performance.now();
      let b = reassertBudget.get(fs);
      if (!b || now - b.windowStart > 6000) {
        b = { n: 0, windowStart: now };
      }
      if (b.n >= 20) return;
      b.n++;
      reassertBudget.set(fs, b);

      onetime.click();
    }, 80);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleRetries);
  } else {
    scheduleRetries();
  }

  document.addEventListener("shopify:section:load", scheduleRetries);
  document.addEventListener("lasso:product-info-updated", () => {
    reassertBudget = new WeakMap();
    scheduleRetries();
  });

  const main = document.querySelector("main");
  if (!main) return;

  let debounceId;
  const mo = new MutationObserver((mutations) => {
    const added = [];
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches?.("fieldset.skio-plan-picker")) added.push(node);
        node.querySelectorAll?.("fieldset.skio-plan-picker")?.forEach((el) => added.push(el));
      }
    }
    if (!added.length) return;
    clearTimeout(debounceId);
    debounceId = setTimeout(() => {
      added.forEach(applyPlanPreference);
      scheduleRetries();
    }, 50);
  });
  mo.observe(main, { childList: true, subtree: true });
})();
